module.exports = __webpack_public_path__ + "img/brand-06.f0e80f19.png";